import RichText from '@/components/utilities/RichText';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const H4 = ({ text, h4align }) => {
  let classNameAlign = 'text-left';
  if (h4align === 'center') {
    classNameAlign = 'text-center mx-auto';
  } else if (h4align === 'right') {
    classNameAlign = 'text-right';
  }

  return (
    <VisibleLoading delay={100}>
      {({ ref, className }) => (
        <h4 ref={ref} className={`xl:max-w-[820px] ${classNameAlign} ${className || ''}`.trim()}>
          <RichText>{text}</RichText>
        </h4>
      )}
    </VisibleLoading>
  );
};
export default H4;
